module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan2-2-d681b89cc389d5e90794e23a97c6696b.webp";